import { render, staticRenderFns } from "./softwareCustomizedMobile.vue?vue&type=template&id=25662d89&scoped=true"
import script from "./softwareCustomizedMobile.vue?vue&type=script&lang=js"
export * from "./softwareCustomizedMobile.vue?vue&type=script&lang=js"
import style0 from "./softwareCustomizedMobile.vue?vue&type=style&index=0&id=25662d89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25662d89",
  null
  
)

export default component.exports